import AdminLayout from "./Components/AdminLayout";
import { useEffect, useState } from "react";
import api from "../../api/api";
import { IMAGE_URL } from "../../path";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

function AdminAboutUs() {
    const [aboutUs, setAboutUs] = useState<any>(null);

    const [headerImage, setHeaderImage] = useState<File | null>(null);
    const [headerPreview, setHeaderPreview] = useState('');

    const [body, setBody] = useState('');

    const [image1, setImage1] = useState<File | null>(null);
    const [image1Preview, setImage1Preview] = useState('');

    const [body1, setBody1] = useState('');

    const [body2, setBody2] = useState('');

    const [image2, setImage2] = useState<File | null>(null);
    const [image2Preview, setImage2Preview] = useState('');

    const [saving, setSaving] = useState(false);

    const bodyEditor = useEditor({
        extensions: [StarterKit],
        content: body,
        immediatelyRender: false,
        onUpdate: ({ editor }) => {
            setBody(editor.getHTML());
        },
    });

    const body1Editor = useEditor({
        extensions: [StarterKit],
        content: body1,
        immediatelyRender: false,
        onUpdate: ({ editor }) => {
            setBody1(editor.getHTML());
        },
    });

    const body2Editor = useEditor({
        extensions: [StarterKit],
        content: body2,
        immediatelyRender: false,
        onUpdate: ({ editor }) => {
            setBody2(editor.getHTML());
        },
    });

    useEffect(() => {
        loadAboutUs();
    }, []);

    useEffect(() => {
        if (bodyEditor) {
            bodyEditor.commands.setContent(body || "");
        }
    }, [body, bodyEditor]);

    useEffect(() => {
        if (body1Editor) {
            body1Editor.commands.setContent(body1 || "");
        }
    }, [body1, body1Editor]);

    useEffect(() => {
        if (body2Editor) {
            body2Editor.commands.setContent(body2 || "");
        }
    }, [body2, body2Editor]);

    const getImageUrl = (path?: string) => {
        if (!path) {
            return "";
        }

        if (path.startsWith("http")) {
            return path;
        }

        return `${IMAGE_URL}/${path}`;
    };

    const loadAboutUs = async () => {
        try {
            const response = await api.get("/about-us");

            const data = response.data;

            if (!data?.id) {
                setAboutUs(null);
                return;
            }

            setAboutUs(data);

            setBody(data.body ?? "");
            bodyEditor?.commands.setContent(data.body ?? "");

            setBody1(data.body_1 ?? "");
            body1Editor?.commands.setContent(data.body_1 ?? "");

            setBody2(data.body_2 ?? "");
            body2Editor?.commands.setContent(data.body_2 ?? "");

            setHeaderPreview(getImageUrl(data.header_image));
            setImage1Preview(getImageUrl(data.image_1));
            setImage2Preview(getImageUrl(data.image_2));

        } catch (error) {
            console.error(error);
        }
    };

    const handleHeaderImage = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        const file = e.target.files?.[0];

        if (!file) {
            return;
        }

        if (file.size > 2 * 1024 * 1024) {

            alert("Image must be 2MB or smaller.");

            return;
        }

        setHeaderImage(file);
        setHeaderPreview(URL.createObjectURL(file));

    };

    const handleImage1 = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        const file = e.target.files?.[0];

        if (!file) {
            return;
        }

        if (file.size > 2 * 1024 * 1024) {

            alert("Image must be 2MB or smaller.");

            return;
        }

        setImage1(file);
        setImage1Preview(URL.createObjectURL(file));

    };

    const handleImage2 = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        const file = e.target.files?.[0];

        if (!file) {
            return;
        }

        if (file.size > 2 * 1024 * 1024) {

            alert("Image must be 2MB or smaller.");

            return;
        }

        setImage2(file);
        setImage2Preview(URL.createObjectURL(file));

    };

    const handleSave = async () => {

        try {

            setSaving(true);

            const formData = new FormData();

            formData.append("body", body);
            formData.append("body_1", body1);
            formData.append("body_2", body2);

            if (headerImage) {
                formData.append("header_image", headerImage);
            }

            if (image1) {
                formData.append("image_1", image1);
            }

            if (image2) {
                formData.append("image_2", image2);
            }

            if (aboutUs?.id) {

                await api.post(
                    `/about-us/${aboutUs.id}?_method=PUT`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

            } else {

                await api.post(
                    "/about-us",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

            }

            await loadAboutUs();

            setHeaderImage(null);
            setImage1(null);
            setImage2(null);

            alert("About Us updated successfully.");

        } catch (error: any) {

            console.error(error);

            alert(
                error?.response?.data?.message ??
                "Failed to save About Us."
            );

        } finally {

            setSaving(false);

        }

    };
    return (
        <AdminLayout>

            <div className="page-header">

                <h1>
                    About Us
                </h1>

                <button
                    className="action-btn"
                    onClick={handleSave}
                    disabled={saving}
                >
                    {saving ? 'Saving...' : 'Save Changes'}
                </button>

            </div>

            <div className="admin-card">

                <h2>Header Image</h2>

                {headerPreview && (
                    <img
                        src={headerPreview}
                        alt=""
                        className="image-preview"
                    />
                )}

                <p className="field-hint">
                    Maximum file size: 2MB
                </p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={handleHeaderImage}
                />

            </div>

            <div className="admin-card description">

                <label>
                    Header Body
                </label>

                <div className="tiptap-editor">
                    <div className="editor-toolbar">

                        <button
                            type="button"
                            onClick={() => bodyEditor?.chain().focus().toggleBold().run()}
                            className={bodyEditor?.isActive("bold") ? "is-active" : ""}
                        >
                            <strong>B</strong>
                        </button>

                        <button
                            type="button"
                            onClick={() => bodyEditor?.chain().focus().toggleItalic().run()}
                            className={bodyEditor?.isActive("italic") ? "is-active" : ""}
                        >
                            <em>I</em>
                        </button>

                    </div>

                    <EditorContent
                        editor={bodyEditor}
                    />
                </div>

            </div>

            <div className="admin-card">

                <h2>Image 1</h2>

                {image1Preview && (
                    <img
                        src={image1Preview}
                        alt=""
                        className="image-preview"
                    />
                )}

                <p className="field-hint">
                    Maximum file size: 2MB
                </p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={handleImage1}
                />

            </div>

            <div className="admin-card description">

                <label>
                    Body 1
                </label>

                <div className="tiptap-editor">
                    <div className="editor-toolbar">

                        <button
                            type="button"
                            onClick={() => body1Editor?.chain().focus().toggleBold().run()}
                            className={body1Editor?.isActive("bold") ? "is-active" : ""}
                        >
                            <strong>B</strong>
                        </button>

                        <button
                            type="button"
                            onClick={() => body1Editor?.chain().focus().toggleItalic().run()}
                            className={body1Editor?.isActive("italic") ? "is-active" : ""}
                        >
                            <em>I</em>
                        </button>

                    </div>

                    <EditorContent
                        editor={body1Editor}
                    />
                </div>

            </div>

            <div className="admin-card description">

                <label>
                    Body 2
                </label>

                <div className="tiptap-editor">
                    <div className="editor-toolbar">

                        <button
                            type="button"
                            onClick={() => body2Editor?.chain().focus().toggleBold().run()}
                            className={body2Editor?.isActive("bold") ? "is-active" : ""}
                        >
                            <strong>B</strong>
                        </button>

                        <button
                            type="button"
                            onClick={() => body2Editor?.chain().focus().toggleItalic().run()}
                            className={body2Editor?.isActive("italic") ? "is-active" : ""}
                        >
                            <em>I</em>
                        </button>

                    </div>

                    <EditorContent
                        editor={body2Editor}
                    />
                </div>

            </div>

            <div className="admin-card">

                <h2>Image 2</h2>

                {image2Preview && (
                    <img
                        src={image2Preview}
                        alt=""
                        className="image-preview"
                    />
                )}

                <p className="field-hint">
                    Maximum file size: 2MB
                </p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={handleImage2}
                />

            </div>

        </AdminLayout>
    )
}

export default AdminAboutUs;
